
export default{
  General:{

    async getSentitems () {
      let orgpartkey = store.state.org.partkey
      let args;
      args = {
        url:store.state.url + 'api/mobile/sentitemsbyorgname/' + orgpartkey,
        method:"POST",
        data:{
          a:store.state.sentitemlimits.a,
          b:store.state.sentitemlimits.b
        }
      }
      store.dispatch('fetch',args).then(d=>{
        Db.sentitems.bulkPut(d)
        store.commit('sentitems', d)
      })
    },


    async loadSentItems(){
      let s = await Db.sentitems.toArray();
      if(s){
        store.commit('sentitems', s)
      }
    },


    async getFlyers (orgpartkey) {
      let args = {
        url:store.state.url+'api/mobile/allflyers/' + orgpartkey,
        method:"GET"
      }
      store.dispatch('fetch',args).then(d=>{
        store.commit('flyers',d)
      })
    },


    getUsage(s){
      if(!s.state.org.textappy.subAccount)return;
      let args;
      args = {
        url:s.state.url + 'api/twilio/getrecordsthismonth',
        method:'POST',
        data:{
          sid:s.state.org.textappy.subAccount.twilioSubSid||''
        }
      };
      if(!s.state.org.textappy.subAccount.twilioSubSid) {return;}
      s.dispatch('fetch',args).then(d=>{
        s.commit('setUsage',d)

      })
    },

  },

  Contacts:{
    async getAll (store) {
      let data = await store.dispatch('get',{path:'api/contacts/allv2'})
      if(data.error){ return data } //return back to the snackbar
      store.commit('setContacts',data)
      window.localStorage.setItem('contacts',JSON.stringify(data))
      store.dispatch('getNewContactCount')
    },

    async getContact(store,uuid) {
      return await store.dispatch('get',{path: 'api/contacts/contactv2/' + uuid})
    },

    //maybe deprecated below.. ?
    async loadActive(offset){
      let data = await Db.contacts.orderBy('name').offset(offset).limit(35).toArray()
      let t = [];
      let a = data.slice(0,7);
      let b = data.slice(7,14);
      let c = data.slice(14,21);
      let d = data.slice(21,28);
      t.push(a,b,c,d)
      store.commit('contacts',t)
    },

    async search(str){
      let data = await Db.contacts.orderBy('name').filter(function(c){
        return c.name.toLowerCase().includes(str.toLowerCase())
      }).toArray()
      let t = [];
      let a = data.slice(0,7);
      let b = data.slice(7,14);
      let c = data.slice(14,21);
      let d = data.slice(21,28);
      t.push(a,b,c,d)
      store.commit('contacts',t)
    },

    async lastName(str){
      let data = await Db.contacts.orderBy('name').filter(function(c){
        return c.name.toLowerCase().split(' ')[1].charAt(0)==str.toLowerCase()
      }).toArray()
      let t = [];
      let a = data.slice(0,7);
      let b = data.slice(7,14);
      let c = data.slice(14,21);
      let d = data.slice(21,28);
      t.push(a,b,c,d)
      store.commit('contacts',t)
    }

  },

  Groups:{
    async getAll (store) {
      store.dispatch('get',{path:'api/groups/getallv3'}) //return an array
          .then((res)=>{
            console.log(res);
            store.commit('setGroups', res)
            window.localStorage.setItem('groups', JSON.stringify(res))
          }).catch(e=> console.log(e) );
    },

    async get (store,groupkey) {
      if(groupkey===undefined)return
      return store.dispatch('get',{path:'api/groups/getv2/' + groupkey})
          .then((res)=>{
            console.log('got group:',res)
            return res
          });
    },

    addtogroup (store,groupkey,data,view) {
      console.log("Data: ",data)
      let em;
      let args;
      args = {
        url:store.state.url + 'api/groups/addtogroupmulti/' + groupkey,
        method:"POST",
        data:data
      }
      return store.dispatch('fetch',args).then(async d=>{
        let group = await Db.groups.get(groupkey)
        let cts = group.Item.contacts;
        let ng = Object.assign(data.item,cts)
        group.Item.contacts = ng;
        this.put(groupkey,group)
        if(view){
          em.view(groupkey)
        }
        console.log("Add To Group Data: ",data); return;
      }).catch(e=>{console.log(e)})
    },

    async removefromgroup (store,data) {
      let args = {
        url:store.state.url + 'api/groups/removefromgroupv2',
        method:"POST",
        data:data
      }
      await store.dispatch('fetch',args).then(res => {
        return res
      });
    },

  }
}